import { AnimateSharedLayout, motion } from 'framer-motion'
import Link from 'next/link'

type ITab = {
    isActive: boolean
    href?: string
    text: string
}

type TabsProps = {
    items: ITab[]
    hasProfileStyling?: boolean
}

export const Tabs = ({ items, hasProfileStyling = false }: TabsProps) => {
    const profileClassNames =
        'w-full relative flex items-center max-w-[150px] md:max-w-[180px] h-full justify-center flex-shrink-0 mr-8'

    return (
        <nav className="relative h-[75px] flex flex-shrink-0 overflow-x-scroll hide-webkit-scrollbar">
            <AnimateSharedLayout>
                {items.map((tab, idx) => (
                    <div
                        key={idx}
                        className={
                            hasProfileStyling
                                ? profileClassNames
                                : 'w-full relative flex items-center max-w-[150px] md:max-w-[285px] h-full justify-center flex-shrink-0 mr-2 md:mr-[150px] min-w-[40vw] md:min-w-0'
                        }
                    >
                        <Link shallow replace href={tab.href ? tab.href : '#'}>
                            <a
                                className={`${
                                    tab.isActive
                                        ? 'opacity-100 font-medium'
                                        : 'opacity-50 font-normal'
                                } cursor-pointer w-full h-full flex items-center justify-center no-underline text-lg`}
                            >
                                {tab.text}
                            </a>
                        </Link>
                        {tab.isActive && (
                            <motion.div
                                className="h-1 bg-yf-green w-full bottom-0 left-0 absolute z-10"
                                layoutId="border"
                                initial={false}
                                animate={{ opacity: 1 }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 400,
                                    damping: 40
                                }}
                            />
                        )}
                    </div>
                ))}
            </AnimateSharedLayout>
        </nav>
    )
}
